package org.example.zone360.components

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class SaveWidgetResponse(
    val data: SaveWidgetData,
)

@Serializable
data class SaveWidgetData(
    val id: String,
    val organization: String,
    val selectedWidgets: List<String>,
    val type: String,
    @SerialName("userID")
    val userId: String? = null,
)


//----------- Payload ---------------
@Serializable
data class SaveWidgetPayload(
    val userId: String? = null,
    val organization: String,
    val selectedWidgets: List<String>,
)
